<h1 mat-dialog-title>{{ 'labels.heading.Keyboard Shortcuts' | translate }}</h1>

<div mat-dialog-content>
  <div class="layout-column gap-2px">
    @for (item of buttonConfig.buttonCombinations; track item) {
      <mat-divider [inset]="true"></mat-divider>
      <div class="flex-fill flex-50">
        <span class="flex-50">
          @if (item.ctrlKey) {
            <span>
              <span class="modifier-key">{{ 'labels.inputs.Ctrl' | translate }}</span> +
            </span>
          }
          @if (item.shiftKey) {
            <span>
              <span class="modifier-key">{{ 'labels.inputs.Shift' | translate }}</span> +
            </span>
          }
          @if (item.altKey) {
            <span>
              <span class="modifier-key">{{ 'labels.inputs.Alt' | translate }}</span> +
            </span>
          }
          @if (item.key) {
            <span>
              <span class="modifier-key">{{ item.key }}</span></span
            >
          }
        </span>
        <span class="flex-50">{{ item.title }}</span>
      </div>
    }
  </div>
</div>
